export default "__VITE_ASSET__891c808b__"